import { render, staticRenderFns } from "./ship-select.vue?vue&type=template&id=b6631964&scoped=true&"
import script from "./ship-select.vue?vue&type=script&lang=js&"
export * from "./ship-select.vue?vue&type=script&lang=js&"
import style0 from "./ship-select.vue?vue&type=style&index=0&id=b6631964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6631964",
  null
  
)

export default component.exports